import { eventActionTypes } from "./events.actionTypes";
import { Network } from "../../../utils/network";

export const updateEventTimeSeries = (data) => async (dispatch, getState) => {
  try {
    const eventDetails = getState()?.eventReducer?.eventDetails ?? {};
    const timeSeriesData = eventDetails?.timeSeriesData ?? [];
    const currentTimeVal = new Date(data.time).valueOf();
    if (data?.price) {
      if (timeSeriesData.length > 0) {
        const last = timeSeriesData[timeSeriesData.length - 1];
        const lastTime = last.time;
        const lastTimeVal = new Date(lastTime).valueOf();
        if (lastTimeVal === currentTimeVal) {
          timeSeriesData[timeSeriesData.length - 1] = data;
          // Update the last point if timestamp is same
          dispatch({
            type: eventActionTypes.UPDATE_EVENT_DATA,
            payload: {
              timeSeriesData,
            },
          });
          return;
        }
      }
      // Append new entry at end if new timestamp
      timeSeriesData.push(data);
      dispatch({
        type: eventActionTypes.UPDATE_EVENT_DATA,
        payload: {
          timeSeriesData,
        },
      });
    }
  } catch (e) {
    console.log(
      `Error in ${eventActionTypes.UPDATE_EVENT_TIME_SERIES} - ${e.message}`
    );
  }
};

export const updateEventDetails =
  (data, isContest) => async (dispatch, getState) => {
    try {
      const eventDetails = getState()?.eventReducer?.eventDetails ?? {};
      const eventid = +data?.id;
      if (eventid === eventDetails?.eventId) {
        if (!Array.isArray(data?.calls)) {
          // tranform Calls from Minified form to Object Array
          if (
            typeof data?.calls === "object" &&
            Object.keys(data?.calls).length > 0
          ) {
            const keys = Object.keys(data?.calls);
            const values = data?.calls?.[keys[0]] ?? [];
            const calls = values.reduce((agg, val, idx) => {
              const item = keys.reduce((dataObj, key) => {
                return {
                  ...dataObj,
                  [key]: data?.calls?.[key]?.[idx],
                };
              }, {});
              return agg.concat(item);
            }, []);
            data.calls = calls;
          }
        }
        dispatch({
          type: eventActionTypes.UPDATE_EVENT_DATA,
          payload: data,
        });
      } else {
        //const wsConnected = getState()?.liveReducer?.connected;
        const ws = getState()?.liveReducer?.wsRef;
        try {
          ws?.send(
            JSON.stringify({
              topic: isContest
                ? `fantasy-probe-detail_${eventid}`
                : `probe-detail_${eventid}`,
              action: "unsubscribe",
            })
          );
          ws?.send(
            JSON.stringify({
              topic: isContest
                ? `fantasy-probe-time-series_${eventid}`
                : `probe-time-series_${eventid}`,
              action: "unsubscribe",
            })
          );
        } catch (e) {}
      }
    } catch (e) {
      console.log(
        `Error in ${eventActionTypes.UPDATE_EVENT_DATA} - ${e.message}`
      );
    }
  };

export const getEventDetails =
  (eventId, contestId) => async (dispatch, state) => {
    try {
      dispatch({
        type: eventActionTypes.SET_EVENT_DATA_LOAD,
      });
      let res;
      if (contestId) {
        res = await Network.getContestEventDetail({ probeid: eventId });
      } else {
        res = await Network.getEventDetail({ probeid: eventId });
      }

      if (res.data) {
        dispatch({
          type: eventActionTypes.SET_EVENT_DATA,
          payload: res.data,
        });
      }
    } catch (e) {
      dispatch({
        type: eventActionTypes.SET_EVENT_DATA_FAIL,
        payload: e.response,
      });
    }
  };
export const getEventDetailsEmpty = () => async (dispatch, state) => {
  dispatch({
    type: eventActionTypes.SET_EVENT_DATA,
    payload: null,
  });
};
